import type { ParticipantId, WallParticipant } from '@walls/store';

export function putCurrentParticipantFirst(
  participants: WallParticipant[],
  currentParticipantId: ParticipantId | null,
  currentParticipantName?: string | null
) {
  const currentParticipantIndex = participants.findIndex(
    (participant) => participant.id === currentParticipantId
  );

  if (currentParticipantIndex >= 0) {
    return moveParticipantToFront(participants, currentParticipantIndex);
  }

  const normalizedCurrentParticipantName = currentParticipantName?.trim().toLowerCase();

  if (!normalizedCurrentParticipantName) {
    return participants;
  }

  const matchingNameIndex = participants.findIndex(
    (participant) => participant.name.trim().toLowerCase() === normalizedCurrentParticipantName
  );

  return matchingNameIndex >= 0
    ? moveParticipantToFront(participants, matchingNameIndex)
    : participants;
}

function moveParticipantToFront(participants: WallParticipant[], participantIndex: number) {
  if (participantIndex === 0) {
    return participants;
  }

  const reorderedParticipants = [...participants];
  const [currentParticipant] = reorderedParticipants.splice(participantIndex, 1);

  return [currentParticipant, ...reorderedParticipants];
}
